export default __webpack_public_path__ + "static/media/logo-jira.a0d23481.svg";